import React from "react";
import { Box, Typography } from "@material-ui/core";

const Footer = ({ marginTop }) => {
  return (
    <Box mt={marginTop ? marginTop : 8}>
      <Typography variant="body2" color="textSecondary" align="center">
        {"Copyright © "} {/* <Link color="inherit" href="/"> */}
        Conqore {/* </Link> */} {new Date().getFullYear()} {"."}
      </Typography>
    </Box>
  );
};

export default Footer;
